import { MultiSelect } from '@workramp/ui';
import { I18n } from '~/common/explicit-exports';
import { useSearch } from '../../providers';
import { UpdatedByAutocomplete } from './UpdatedByAutocomplete';

export const AdvancedSearchFilterUpdatedBy = () => {
  const UPDATED_BY = I18n.t('js.learner.search.advanced_search.updated_by');

  const { selectedUpdatedByUserIds, setSelectedUpdatedByUserIds } = useSearch();

  return (
    <MultiSelect
      label={UPDATED_BY}
      numSelections={selectedUpdatedByUserIds.length}
      title={UPDATED_BY}
      width={480}
      onClear={() => setSelectedUpdatedByUserIds([])}
    >
      <UpdatedByAutocomplete
        autoFocus
        selectedUpdatedByUserIds={selectedUpdatedByUserIds}
        setSelectedUpdatedByUserIds={setSelectedUpdatedByUserIds}
      />
    </MultiSelect>
  );
};
